import { useHelpers } from '../../../providers/HelpersProvider';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderHelpers from '../../../services/helpers/OrderHelpers';
import AddressHelpers from '../../../services/helpers/AddressHelpers';
import { useSelector } from 'react-redux';
import { Tag } from 'antd';
import { collect } from 'collect.js';

export default function OrderSummary({ order }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:AlertScreens:Shared:OrderSummary' });

  const { formatCurrency } = useHelpers();
  const company = useSelector((state) => state.company?.company);
  const isDelivery = OrderHelpers.isDelivery(order);

  const getTagColor = (tag) =>
    ({
      new_customer: 'default',
      loyal_customer: 'gold',
    })[tag] ?? 'black';

  return (
    <div className="flex justify-between">
      <div>
        <h6>
          {t(`labels.order`)} #{order.number}
        </h6>
        <span className="text-gray-700 block">
          {t(`labels.customer`)}: {order.customer_first_name} {order.customer_last_name}
        </span>
        {isDelivery && (
          <span className="block">
            {AddressHelpers.format(
              {
                street_name: order.delivery_street_name,
                street_number: order.delivery_street_number,
                zip_code: order.delivery_zip_code,
                city: order.delivery_city,
              },
              company?.region?.address_format,
            )}
          </span>
        )}
        {order.tags.length > 0 && (
          <div className="mt-xs flex gap-xs">
            {collect(order.tags)
              .unique()
              .map((item) => (
                <Tag key={item} color={getTagColor(item)} className="rounded-2xl font-medium">
                  {t(`tags.${item}`, { defaultValue: item })}
                </Tag>
              ))}
          </div>
        )}
      </div>
      <h6 className="text-md font-bold">{formatCurrency(order.total_amount)}</h6>
    </div>
  );
}
